export default function createAssetMarker(asset) {
  const html = `
    <div class="site-asset-icon ${asset.assetType.toLowerCase()}">
      <span class="text-center fa fa-map-marker"></span>
    </div>
  `;
  return html;
}
